<div [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}" class="inner-content">
  <main class="project-info" *ngIf="organization">

    <app-org-name-step [organization]="organization" [new]="false"></app-org-name-step>
	  <app-org-table-users-step [organization]="organization" [infrastructure]="infrastructure" ></app-org-table-users-step>

  </main>
</div>
